// @flow
import React from "react"
import Img from "gatsby-image"
import { rhythm, adjustFontSizeTo } from "../utils/typography"
import { white } from "../utils/colors"

type Props = {
  ...Testimonial,
  minHeight?: string,
  className?: any,
}

const QuoteBubble = ({
  quote,
  sourceName,
  sourceTitle,
  sourceImage,
  backgroundColor,
  minHeight,
  className,
  companyLogo,
  ...props
}: Props) => {
  // set quote background color
  let themeStyles = {
    backgroundColor: backgroundColor,
    "&:after": {
      borderTopColor: backgroundColor,
    },
  }
  // if minHeight is provided, add it to themeStyles
  if (minHeight) themeStyles.minHeight = minHeight
  // if sourceImage is provided, add extra padding left
  let sourceStyles = sourceImage
    ? { paddingLeft: rhythm(7 / 2) }
    : { paddingLeft: rhythm() }

  return (
    <div css={[styles.wrapper, className]} {...props}>
      <div css={styles.inner}>
        <div css={[styles.quote, themeStyles]}>
          <p css={styles.quoteText}>&ldquo;{quote}&rdquo;</p>
        </div>
        <div css={[styles.source, sourceStyles]}>
          {sourceImage && (
            <div css={styles.sourceImage}>
              <Img resolutions={sourceImage.resolutions} />
            </div>
          )}
          <div>
            <span css={styles.sourceName}>{sourceName},</span>
            <span css={styles.sourceTitle}>{sourceTitle}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

const styles = {
  wrapper: {},
  inner: {
    margin: "0 auto",
  },
  quote: {
    display: "flex",
    alignItems: "center",
    padding: rhythm(3 / 2),
    marginBottom: rhythm(3 / 2),
    borderRadius: "16px",
    color: white,
    WebkitFontSmoothing: "antialiased",
    position: "relative",
    "&:after": {
      content: "' '",
      position: "absolute",
      bottom: "0",
      left: "18%",
      width: "0",
      height: "0",
      border: `${rhythm(5 / 4)} solid transparent`,
      borderBottom: "0",
      borderRight: "0",
      marginLeft: `-${rhythm()}`,
      marginBottom: `-${rhythm(1)}`,
    },
  },
  quoteText: {
    maxWidth: "19.625em",
    margin: "0 auto",
    fontStyle: "italic",
    fontWeight: 600,
  },
  source: {
    display: "flex",
    minHeight: rhythm(3),
    alignItems: "center",
  },
  sourceImage: {
    minWidth: "3.25rem",
    width: "3.25rem",
    height: "3.25rem",
    marginRight: rhythm(1 / 2),
    " img": {
      borderRadius: "2em",
      margin: "0",
    },
  },
  sourceName: {
    display: "block",
    fontWeight: "600",
  },
  sourceTitle: {
    ...adjustFontSizeTo("14px"),
    lineHeight: "1.3",
    display: "block",
  },
}

export default QuoteBubble



// WEBPACK FOOTER //
// ./src/components/QuoteBubble.js